/**
 * chatIcons.ts — daylist の LINE / 自社チャット（予約チャット）アイコンの色（2026-10-30・booking-platform/md/customer-chat.md §13-7）
 *
 * 以前はどちらも絵文字の 💬 で、自社チャットは hue-rotate で色を変えていたが、Mac の 💬 は白とグレーなので
 * 色相を回しても変わらず 2 つが同じに見えた。色を指定できる MUI の ChatBubble に替え、色で見分ける。
 */
export const LINE_CHAT_COLOR = '#06C755';
export const LINE_CHAT_COLOR_HOVER = '#05b34c';
export const RESV_CHAT_COLOR = '#1976d2';
export const RESV_CHAT_COLOR_HOVER = '#1565c0';
/** LINE 未連携のグレー */
export const CHAT_ICON_DISABLED_COLOR = '#9e9e9e';
